import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditAgeReports } from '../services/selectors';

export const useSecurityAuditAgeReports = () => useAppSelector(selectSecurityAuditAgeReports);
